module.exports = __webpack_public_path__ + "img/immediate1.c09e5ff4.png";